(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bsw-wig-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const setup = () => {
    document.querySelectorAll('[data-bsw-wig="desktop"]').forEach(details => {
      if (details.dataset.bswReady) return;
      details.dataset.bswReady = 'true';
      let timer;
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        document.querySelectorAll('[data-bsw-wig="desktop"][open]').forEach(other => {
          if (other !== details) other.open = false;
        });
      });
      const trigger = details.querySelector(':scope > summary');
      const close = () => { clearTimeout(timer); details.open = false; };
      details.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(timer);
        details.open = true;
      });
      details.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(timer);
        timer = setTimeout(() => {
          if (!details.contains(document.activeElement)) details.open = false;
        }, 180);
      });
      details.addEventListener('focusout', event => {
        if (!details.contains(event.relatedTarget)) close();
      });
      details.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          close();
          trigger.focus();
        }
      });
    });
  };
  document.addEventListener('pointerdown', event => {
    document.querySelectorAll('[data-bsw-wig="desktop"][open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('shopify:section:load', setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
  } catch(e) { console.error(e); }
})();

})();
